import { type PropsWithChildren } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router";

import { SettingsProvider as IqfSettingsProvider } from "iqf-web-ui/settings";

import { deriveUdzsSorting } from "udzs-common/utils";

import { Link } from "@/components/link";

export function SettingsProvider({ children }: PropsWithChildren) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  return (
    <IqfSettingsProvider
      router={{
        Link,
        navigate: (href) => {
          if (href) {
            navigate(href);
          }
        },
        pathname,
        searchParams,
        useParams,
      }}
      zod={{
        enableQueryLogging: true,
      }}
      table={{ deriveSorting: deriveUdzsSorting }}
    >
      {children}
    </IqfSettingsProvider>
  );
}
